import * as React from 'react';
import { useEffect, useState } from 'react';
import IconButton from '@mui/material/IconButton';
import Image from 'next/image';
import { styled } from '@mui/material/styles';
import { debounce } from 'lodash-es';
import { IconButtonProps } from '@mui/material';
import { TopToScrollButtonZIndex } from '@/constant/z-index';

type P = {
  scrollableDivRef?: React.RefObject<HTMLElement | null>;
  scrollToTopBottomOffset?: number;
} & IconButtonProps;

const TopToScroll = ({
  scrollableDivRef,
  scrollToTopBottomOffset,
  ...other
}: P) => {
  const [isVisible, setIsVisible] = useState(false);
  const scrollableDivElement = scrollableDivRef?.current;

  useEffect(() => {
    const handleScroll = debounce(() => {
      const scrollTop = scrollableDivElement
        ? scrollableDivElement.scrollTop
        : Math.max(document.documentElement.scrollTop, document.body.scrollTop);

      if (scrollTop > 20) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    }, 100);

    if (typeof window !== 'undefined') {
      const target = scrollableDivElement ?? window;
      target?.addEventListener?.('scroll', handleScroll);
    }

    return () => {
      if (typeof window !== 'undefined') {
        const target = scrollableDivElement ?? window;
        target?.removeEventListener?.('scroll', handleScroll);
      }
    };
  }, [scrollableDivElement]);

  const scrollToTop = () => {
    if (typeof window !== 'undefined') {
      const target = scrollableDivElement ?? window;
      target.scrollTo({
        top: 0,
        behavior: 'smooth', // 부드러운 스크롤 효과
      });
    }
  };
  return (
    <TopToWrapper
      onClick={scrollToTop}
      style={{
        display: isVisible ? 'block' : 'none',
        bottom: scrollToTopBottomOffset
          ? `${scrollToTopBottomOffset}px`
          : '24px',
      }}
      {...other}
    >
      <Image
        src={'/icons/arrow-up.svg'}
        alt={'scroll on Top'}
        width={14}
        height={14}
      />
    </TopToWrapper>
  );
};

export default TopToScroll;

const TopToWrapper = styled(IconButton)(() => ({
  position: 'fixed',
  bottom: '24px',
  right: '16px',
  zIndex: TopToScrollButtonZIndex,
  // 다크에서는 바탕보다 한 단계 밝은 면 (떠 있는 버튼)
  background: 'var(--dk-bg-muted, white)',
  borderRadius: '24px',
  width: '48px',
  height: '48px',
  boxShadow:
    '0px 0px 2px 0px rgba(0, 0, 0, 0.12), 0px 16px 16px 0px rgba(0, 0, 0, 0.12)',
  backdropFilter: 'blur(10px)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  transition: 'all 0.2s ease-in',
}));
